export const RESULT = 'RESULT';
export const STATE = 'STATE';
export const STATE_SURVEY = 'STATE_SURVEY';
export const QUESTION = 'QUESTION';
export const EXPAND = 'EXPAND';
export const PROMO_STATE = 'PROMO_STATE';
